import { render, staticRenderFns } from "./LoanGuarantor.vue?vue&type=template&id=2c1029ec&scoped=true"
import script from "./LoanGuarantor.vue?vue&type=script&lang=js"
export * from "./LoanGuarantor.vue?vue&type=script&lang=js"
import style0 from "./LoanGuarantor.vue?vue&type=style&index=0&id=2c1029ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1029ec",
  null
  
)

export default component.exports